import { useUrlState } from "@/lib/use-url-state";
import type { ExperimentEvaluator } from "../types";
import { Select } from "@/components/ui/select";

const STATUSES = [
  { value: "", label: "All items" },
  { value: "done", label: "Done" },
  { value: "failed", label: "Agent errors" },
  { value: "not_run", label: "Not run" },
  { value: "pending", label: "Queued" },
  { value: "running", label: "Running" },
];

export function sortName(sort: string, evaluators: ExperimentEvaluator[]): string {
  if (sort.startsWith("score:")) {
    const key = sort.slice(6);
    return evaluators.find((e) => e.key === key)?.name ?? key;
  }
  return { position: "dataset order", latency: "latency", cost: "cost" }[sort] ?? sort;
}

export function ItemsToolbar({ evaluators }: { evaluators: ExperimentEvaluator[] }) {
  const url = useUrlState();
  const sort = url.get("sort") ?? "position";
  const order = url.get("order") ?? "asc";

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Select
        label="Item status"
        value={url.get("status") ?? ""}
        onChange={(status) => url.set({ status, page: null })}
        options={STATUSES}
      />
      <Select
        label="Lowest score first"
        value={sort.startsWith("score:") && order === "asc" ? sort : ""}
        onChange={(v) => url.set({ sort: v || null, order: v ? "asc" : null, page: null })}
        options={[
          { value: "", label: "Lowest score first…" },
          ...evaluators.map((ev) => ({ value: `score:${ev.key}`, label: `Lowest ${ev.name}` })),
        ]}
      />
      <Select
        label="Not applicable"
        value={url.get("na") ?? ""}
        onChange={(na) => url.set({ na })}
        options={[
          { value: "", label: "Any applicability" },
          ...evaluators.map((ev) => ({ value: ev.key, label: `Not applicable: ${ev.name}` })),
        ]}
      />
      <span className="flex-1" />
      <span className="text-xs text-muted">
        Sorted by {sortName(sort, evaluators)} {sort !== "position" && (order === "asc" ? "↑" : "↓")} · click
        a column to sort · click a row for details
      </span>
    </div>
  );
}
